/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskQueuesCreateViewType from '@jira/spa-apps__servicedesk-queues-create-view/src/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskQueuesCreateView: LazyComponent<
	({ hideBreadcrumbs }: { hideBreadcrumbs?: boolean }) => React.JSX.Element
> = lazyForPaint<typeof ServicedeskQueuesCreateViewType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-queues-create-view", jiraSpaEntry: "async-servicedesk-queues-create-view" */ '@jira/spa-apps__servicedesk-queues-create-view/src/index.tsx'
		),
	),
);

const AsyncServicedeskQueuesCreateView = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskQueuesCreateView}
		pageId="spa-apps/servicedesk/queues/create"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskQueuesCreateView;
